const text_page = document.querySelector('.text-page');
if (text_page) {
	const newsletter = document.querySelector('.shopify-section-group-footer-group');
	const markets = document.querySelector('.markets');

	if (newsletter) {
		newsletter.style.display = 'none';
	}

	if (markets) {
		markets.style.display = 'none';
	}
}

function getKlavyioForm() {
	const klaviyo_form_id = 'RTQKqy';
	window._klOnsite = window._klOnsite || [];
	window.addEventListener('klaviyoForms', function (e) {
		if (e.detail.type == 'submit' && e.detail.formId == klaviyo_form_id) {
			setTimeout(() => {
				window.location.href = window.location.pathname + '?subscribed=true';
			}, 250);
		}
	});
}

function openChatBotWithDelay() {
	setTimeout(() => {
		const chatBot = document.querySelector('iframe#launcher');
		if (!chatBot) return;
		chatBot.style.display = 'block';
	}, 10000);
}

document.addEventListener('DOMContentLoaded', () => {
	getKlavyioForm();

	// openChatBotWithDelay();
});
